import { FormLabel, Input, Text } from '@chakra-ui/react';

const EmailInput = () => (
    <div>
        <FormLabel display="flex" fontSize="md" fontWeight="700" color="gray.900" mb="8px">
            Email<Text color="red.500">&nbsp;*</Text>
        </FormLabel>
        <Input
            isRequired={true}
            variant="auth"
            fontSize="md"
            ms={{ base: '0px', md: '0px' }}
            type="email"
            placeholder="example@mail.com"
            mb="24px"
            fontWeight="500"
            size="lg"
        />
    </div>
);

export default EmailInput;
